import { Box, styled } from "@mui/material";

function Header({ variant }) {
  return (
    <BoxIcon color={variant === "success" ? "success" : "error"}>
      {variant === "success" ? (
        <ion-icon name="checkmark-circle-outline" />
      ) : (
        <ion-icon name="alert-outline" />
      )}
    </BoxIcon>
  );
}

const BoxIcon = styled(Box)(({ color, theme }) => ({
  position: "absolute",
  top: "-25px",
  width: "50px",
  height: "50px",
  left: "50%",
  WebkitTransform: "translateX(-50%)",
  transform: "translateX(-50%)",
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  backgroundColor: theme.palette[color].main,
  justifyContent: "center",

  "ion-icon": {
    fontSize: "30px",
    color: theme.palette.common.white
  },
}));

export default Header;
